import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "custom-global-skeleton assessment-progress tw-bg-[#ffffff] tw-min-w-[241px] tw-max-w-[241px] tw-p-[25px] tw-pr-[9.5px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1] tw-gap-[20px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tw-font-Poppins tw-text-[12px] tw-font-[600] tw-text-[#211F58] tw-uppercase tw-leading-[100%] tw-tracking-[1.2px] tw-w-[100px] tw-h-[12px]" }, null, -1)
const _hoisted_3 = {
  id: "progress-box",
  class: /*#__PURE__*/_normalizeClass([
        'category-container tw-w-full tw-gap-[25px] tw-mb-0 tw-py-[5px] tw-flex tw-flex-col !tw-pl-0',
      ])
}

import { ref } from "vue";
// eslint-disable-next-line no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentProgressSkeleton',
  props: {
  /** The title of assessment progress */
  title: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;


const activeCategory = ref(0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ol", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], (item) => {
        return _createElementVNode("li", {
          key: item,
          class: _normalizeClass([
          'tw-select-none tw-cursor-pointer tw-w-full tw-font-Poppins tw-text-[15px] tw-text-[#211F58] tw-leading-[120%] tw-pr-[9.5px]',
          activeCategory.value === item ? 'tw-font-[600]' : '',
        ])
        }, null, 2)
      }), 64))
    ])
  ]))
}
}

})